export default __webpack_public_path__ + "static/media/icons8-septic.0fc028f9.svg";